// Auto-generated - do not edit manually
import React from "react";
import { BaseIcon } from "../../BaseIcon";
import type { BaseIconProps } from "../../types";

const solidContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><g id="icon_underline-text--line"><path id="Union" d="M21 21H3V19H21V21ZM7 10C7 12.7614 9.23858 15 12 15C14.7614 15 17 12.7614 17 10V3H19V10C19 13.866 15.866 17 12 17C8.13401 17 5 13.866 5 10V3H7V10Z" style="fill: currentColor"/></g></svg>`;
const lineContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><g id="icon_underline-text--line"><path id="Union" d="M21 21H3V19H21V21ZM7 10C7 12.7614 9.23858 15 12 15C14.7614 15 17 12.7614 17 10V3H19V10C19 13.866 15.866 17 12 17C8.13401 17 5 13.866 5 10V3H7V10Z" style="fill: currentColor"/></g></svg>`;

export const UnderlineText: React.FC<BaseIconProps> = (props) => (
  <BaseIcon {...props} solidContent={solidContent} lineContent={lineContent} />
);
